import React from 'react';

const getStyle = (cell) => {
  let style = {};
  if (cell.width) {
    style.minWidth = `${cell.width}px`;
  }
  if (cell.sticky) {
    style.position = 'sticky';
    style.left = cell.left;
  }

  if (cell.style) {
    style = {...style, ...cell.style};
  }

  return style;
};
const Row = ({columns, row}) => (
  <tr>
    {columns.map((cell, index) => {
      const width = cell.width ? {width: cell.width} : {};
      if (cell.field) {
        return (
          <td
            key={index}
            style={getStyle(cell)}
            className={cell.className || cell.bodyClass}
            dangerouslySetInnerHTML={{
              __html: cell.uppercase
                ? row[cell.field].toUpperCase()
                : row[cell.field],
            }}
          ></td>
        );
      }
      if (typeof cell.render === 'function') {
        return (
          <td
            key={index}
            style={getStyle(cell)}
            className={cell.className || cell.bodyClass}
          >
            {cell.render(row)}
          </td>
        );
      }
      return (
        <td
          {...width}
          style={getStyle(cell)}
          className={cell.className || cell.bodyClass}
          key={index}
        ></td>
      );
    })}
  </tr>
);

export default Row;
